import { useEffect, useState } from 'react';

/**
 * قاب ثابت لوگوی سازمان. عرض و ارتفاع برای همهٔ ردیف‌ها یکی است
 * تا لیست نامنظم نشود. آواتار کاربران جدا می‌ماند.
 */
export default function OrganizationLogoMark({
  imageUrl,
  label,
  accentColor = '#94a3b8',
  height = 40,
  width,
  maxWidth = 112,
}) {
  const frameWidth = width ?? maxWidth;
  const [failed, setFailed] = useState(false);
  const src = typeof imageUrl === 'string' && imageUrl.trim() ? imageUrl.trim() : '';
  const initial = (label || '؟').trim().charAt(0) || '؟';
  const monogram = Math.max(22, Math.min(28, height - 12));
  const boxStyle = {
    width: frameWidth,
    height,
    minWidth: frameWidth,
    maxWidth: frameWidth,
    minHeight: height,
    maxHeight: height,
  };

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const frameClass = 'box-border inline-flex shrink-0 items-center justify-center self-center overflow-hidden rounded-lg border border-slate-200/90 bg-white p-1 dark:border-white/10 dark:bg-white';

  if (!src || failed) {
    return (
      <span className={frameClass} style={boxStyle}>
        <span
          className="inline-flex items-center justify-center rounded-md text-[13px] font-bold leading-none text-white"
          style={{ width: monogram, height: monogram, background: accentColor }}
        >
          {initial}
        </span>
      </span>
    );
  }

  return (
    <span className={frameClass} style={boxStyle}>
      <img
        src={src}
        alt={label || ''}
        className="block h-auto max-h-full w-auto max-w-full object-contain"
        loading="lazy"
        onError={() => setFailed(true)}
      />
    </span>
  );
}
